/**
 * Custom Cart Drawer Logic (Final: Carousel Fix)
 * Removed JS limit to allow full carousel scrolling.
 */

document.addEventListener('DOMContentLoaded', function() {
  initCustomCartLogic();
  setupNetworkInterceptors();
});

// Re-init if theme re-renders the section
document.addEventListener('shopify:section:load', function(e) {
  if (e.target.querySelector('[data-section-type="cart-drawer"]')) {
    initCustomCartLogic();
  }
});

function initCustomCartLogic() {
  refreshDrawerComponents();

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      sanitizeUpsells(cart.items);
      updateCartBubble(cart.item_count);
    });

  document.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('.custom-cart-remove');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = removeBtn.getAttribute('data-variant-id');
      const lineIndex = removeBtn.getAttribute('data-line-index');
      removeItem(variantId, lineIndex);
    }
  });
}

// --- NETWORK INTERCEPTOR ---
function setupNetworkInterceptors() {
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then((response) => {
      if (response.ok && response.url) {
        if (response.url.includes('/cart/add') || 
            response.url.includes('/cart/change') || 
            response.url.includes('/cart/update') || 
            response.url.includes('/cart/clear')) {
           
           if (!response.url.includes('stealth=true')) {
               setTimeout(() => { refreshDrawerComponents(); }, 200);
           }
        }
      }
      return response;
    });
  };

  const originalXHR = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    this.addEventListener('load', function() {
      if (this.status >= 200 && this.status < 300) {
        if (typeof this._url === 'string' && 
           (this._url.includes('/cart/add') || 
            this._url.includes('/cart/change') || 
            this._url.includes('/cart/update'))) {
            
            if (!this._url.includes('stealth=true')) {
               setTimeout(() => { refreshDrawerComponents(); }, 200);
            }
        }
      }
    });
    return originalXHR.apply(this, arguments);
  };
  
  document.addEventListener('cart:request:success', function() {
      setTimeout(() => { refreshDrawerComponents(); }, 50);
  });
}

// --- CORE: FETCH & SWAP ---
function refreshDrawerComponents() {
  const drawerSection = document.querySelector('[data-section-type="cart-drawer"]');
  if (!drawerSection) return;
  const sectionId = drawerSection.getAttribute('data-section-id');

  fetch(window.location.pathname + '?section_id=' + sectionId + '&time=' + new Date().getTime())
    .then(response => response.text())
    .then(html => {
      updateDrawerHTML(html);
      
      fetch('/cart.js').then(r=>r.json()).then(c => {
          updateCartBubble(c.item_count);
          sanitizeUpsells(c.items);
      });
    })
    .catch(console.error);
}

function updateDrawerHTML(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  const newItems = doc.querySelector('#custom-cart-items');
  const currentItems = document.querySelector('#custom-cart-items');
  if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

  const newSummary = doc.querySelector('#cart-drawer-summary');
  const currentSummary = document.querySelector('#cart-drawer-summary');
  if (newSummary && currentSummary) currentSummary.innerHTML = newSummary.innerHTML;

  const newFormWrapper = doc.querySelector('#custom-cart-form-wrapper');
  const currentFormWrapper = document.querySelector('#custom-cart-form-wrapper');
  if (newFormWrapper && currentFormWrapper) {
      currentFormWrapper.className = newFormWrapper.className;
      if (!currentFormWrapper.classList.contains('cart--hidden')) {
          currentFormWrapper.style.display = 'block';
      }
  }
  
  const newEmpty = doc.querySelector('#custom-cart-empty');
  const curEmpty = document.querySelector('#custom-cart-empty');
  if (newEmpty && curEmpty) curEmpty.className = newEmpty.className;

  const newBottom = doc.querySelector('#custom-drawer-bottom');
  const curBottom = document.querySelector('#custom-drawer-bottom');
  if (newBottom && curBottom) curBottom.className = newBottom.className;

  const newUpsell = doc.querySelector('#cart-drawer-upsell-container');
  const currentUpsell = document.querySelector('#cart-drawer-upsell-container');
  if (newUpsell && currentUpsell) currentUpsell.innerHTML = newUpsell.innerHTML;
}

// --- ACTIONS ---
window.addUpsellToCart = function(event, btn) {
  if (event) { event.preventDefault(); event.stopPropagation(); }
  
  const container = btn.closest('.upsell__item');
  const selector = container.querySelector('.upsell__variant-selector');
  let variantId = selector ? selector.value : container.getAttribute('data-default-variant-id');
  const drawerSection = document.querySelector('[data-section-type="cart-drawer"]');
  const sectionId = drawerSection ? drawerSection.getAttribute('data-section-id') : 'cart-drawer';

  if (variantId) {
    const originalText = btn.innerHTML;
    btn.innerHTML = '...';
    btn.style.opacity = '0.7';

    const formData = {
      'items': [{ 'id': variantId, 'quantity': 1 }],
      'sections': sectionId, 
      'sections_url': window.location.pathname
    };

    fetch('/cart/add.js?stealth=true', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
       if (data.sections && data.sections[sectionId]) {
         btn.innerHTML = '<span>TOEGEVOEGD!</span>';
         updateDrawerHTML(data.sections[sectionId]);
         
         fetch('/cart.js').then(r=>r.json()).then(c => {
             updateCartBubble(c.item_count);
             sanitizeUpsells(c.items);
         });
       } else {
         refreshDrawerComponents();
         btn.innerHTML = originalText;
       }
    })
    .catch(err => {
       console.error(err);
       btn.innerHTML = originalText;
       btn.style.opacity = '1';
    });
  }
};

function removeItem(variantId, lineIndex) {
  const drawerSection = document.querySelector('[data-section-type="cart-drawer"]');
  const sectionId = drawerSection ? drawerSection.getAttribute('data-section-id') : 'cart-drawer';

  const payload = {
    'line': lineIndex, 
    'quantity': 0,
    'sections': sectionId,
    'sections_url': window.location.pathname
  };

  fetch('/cart/change.js?stealth=true', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(res => res.json())
  .then(data => {
      if (data.sections && data.sections[sectionId]) {
         updateDrawerHTML(data.sections[sectionId]);
         updateCartBubble(data.item_count);
         sanitizeUpsells(data.items);
      } else {
         refreshDrawerComponents();
      }
  })
  .catch(console.error);
}

function updateCartBubble(count) {
    const bubble = document.querySelector('.cart-count-bubble, .header__cart-count');
    if (bubble) {
       bubble.innerText = count;
       if (count > 0) bubble.classList.remove('hidden');
    }
}

// --- UPSELL LOGIC (FIXED) ---
window.sanitizeUpsells = function(cartItems) {
  const items = document.querySelectorAll('.upsell__item');
  const holder = document.querySelector('.upsell__holder');
  if (!items.length) return;

  let visibleCount = 0;
  const limit = 50; // <--- FIX IS HERE (Was 2)

  items.forEach(el => {
    const prodId = parseInt(el.getAttribute('data-product-id'));
    const inCart = cartItems ? cartItems.some(item => item.product_id === prodId) : false;

    if (inCart) {
      el.style.display = 'none';
    } else {
      if (visibleCount < limit) {
        // Use flex so it respects the CSS layout
        el.style.display = 'flex';
        visibleCount++;
      } else {
        el.style.display = 'none';
      }
    }
  });

  if (holder) {
    holder.style.display = visibleCount > 0 ? 'block' : 'none';
  }
};